import { BRAND_NAME } from "@cms/config";
import React from "react";
import {
  LayoutDashboard,
  Users,
  CreditCard,
  Activity,
  LifeBuoy,
  Server,
  type LucideIcon,
} from "lucide-react";
import {
  SidebarShell,
  SidebarNavItem,
  SidebarEnvIndicator,
  SidebarUserMenu,
} from "@cms/ui/components/sidebar";
import type { AdminUser } from "../lib/outlet-context";

interface NavEntry {
  label: string;
  href: string;
  icon: LucideIcon;
  exact?: boolean;
}

const primaryNav: NavEntry[] = [
  { label: "Dashboard", href: "/dashboard", icon: LayoutDashboard, exact: true },
  { label: "Clients", href: "/clients", icon: Users },
  { label: "Billing", href: "/billing", icon: CreditCard },
  { label: "Activity", href: "/activity", icon: Activity },
  { label: "Support", href: "/support", icon: LifeBuoy },
  { label: "Infrastructure", href: "/infrastructure", icon: Server },
];

export function Sidebar({ user, environment, onSignOut }: {
  user: AdminUser | null;
  environment: string | null;
  onSignOut?: () => void;
}) {
  return (
    <SidebarShell
      title={BRAND_NAME}
      subtitle="Admin Console"
      footer={
        <>
          <SidebarEnvIndicator environment={environment ?? undefined} />
          <SidebarUserMenu email={user?.email || ""} accountHref="/account" onSignOut={onSignOut} />
        </>
      }
    >
      <div className="space-y-0.5">
        {primaryNav.map((item) => (
          <SidebarNavItem key={item.href} {...item} />
        ))}
      </div>
    </SidebarShell>
  );
}
